var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaves(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 105,
    viewBox: "0 0 156 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4329_90392",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 279,
    height: 280
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 143.5,
    cy: 139.518,
    r: 137.576,
    fill: "#C4C4C4",
    stroke: "#F8BB54",
    strokeWidth: 3.84828
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4329_90392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-77.0703 58.5217C-77.0703 58.5217 -12.111 46.4885 4.64937 4.37288C20.6784 -35.9996 86.7065 -46.8516 86.7065 -46.8516",
    stroke: "#FA2727",
    strokeWidth: 4.32558,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.0703 78.7637C-77.0703 78.7637 2.62465 64.8754 23.153 14.0443C42.7252 -34.4814 123.657 -46.8516 123.657 -46.8516",
    stroke: "#FA2727",
    strokeWidth: 4.32558,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.0703 99.0626C-77.0703 99.0626 17.3038 83.2623 41.6004 23.8282C64.7721 -33.0192 160.609 -46.8516 160.609 -46.8516",
    stroke: "#FA2727",
    strokeWidth: 4.32558,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.0703 119.305C-77.0703 119.305 32.0392 101.649 60.104 33.4997C86.819 -31.501 197.56 -46.8516 197.56 -46.8516",
    stroke: "#FA2727",
    strokeWidth: 4.32558,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.0703 139.548C-77.0703 139.548 46.7747 120.036 78.6076 43.2272C108.866 -29.9828 234.455 -46.8516 234.455 -46.8516",
    stroke: "#FA2727",
    strokeWidth: 4.32558,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.0703 159.846C-77.0703 159.846 61.4538 138.479 97.0551 52.9546C130.969 -28.5211 271.405 -46.8516 271.405 -46.8516",
    stroke: "#FA2727",
    strokeWidth: 4.32558,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.0703 180.089C-77.0703 180.089 76.1892 156.81 115.559 62.6825C153.016 -27.0029 308.356 -46.8516 308.356 -46.8516",
    stroke: "#FA2727",
    strokeWidth: 4.32558,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.0703 200.331C-77.0703 200.331 90.9248 175.197 134.006 72.354C175.063 -25.4846 345.308 -46.8516 345.308 -46.8516",
    stroke: "#FA2727",
    strokeWidth: 4.32558,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.0703 220.63C-77.0703 220.63 105.604 193.64 152.51 82.1375C197.11 -24.0229 382.202 -46.8516 382.202 -46.8516",
    stroke: "#FA2727",
    strokeWidth: 4.32558,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.0703 240.871C-77.0703 240.871 120.339 212.027 170.957 91.8654C219.156 -22.5046 419.153 -46.8516 419.153 -46.8516",
    stroke: "#FA2727",
    strokeWidth: 4.32558,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.0703 261.17C-77.0703 261.17 135.075 230.413 189.461 101.593C241.204 -20.9865 456.104 -46.8516 456.104 -46.8516",
    stroke: "#FA2727",
    strokeWidth: 4.32558,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.0703 281.414C-77.0703 281.414 149.754 248.801 207.908 111.321C263.25 -19.5243 493.054 -46.8516 493.054 -46.8516",
    stroke: "#FA2727",
    strokeWidth: 4.32558,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.0703 301.654C-77.0703 301.654 164.489 267.188 226.412 120.992C285.297 -18.0061 530.005 -46.8516 530.005 -46.8516",
    stroke: "#FA2727",
    strokeWidth: 4.32558,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.0703 321.953C-77.0703 321.953 179.225 285.575 244.915 130.776C307.344 -16.4879 566.901 -46.8516 566.901 -46.8516",
    stroke: "#FA2727",
    strokeWidth: 4.32558,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.0703 342.197C-77.0703 342.197 193.904 303.961 263.363 140.447C329.391 -15.0261 603.852 -46.8516 603.852 -46.8516",
    stroke: "#FA2727",
    strokeWidth: 4.32558,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.0703 362.441C-77.0703 362.441 208.639 322.348 281.866 150.175C351.438 -13.5079 640.803 -46.8516 640.803 -46.8516",
    stroke: "#FA2727",
    strokeWidth: 4.32558,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.0703 382.74C-77.0703 382.74 223.375 340.79 300.314 159.902C373.485 -11.9897 677.754 -46.8516 677.754 -46.8516",
    stroke: "#FA2727",
    strokeWidth: 4.32558,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.0703 402.98C-77.0703 402.98 238.054 359.122 318.817 169.63C395.532 -10.5279 714.65 -46.8516 714.65 -46.8516",
    stroke: "#FA2727",
    strokeWidth: 4.32558,
    strokeMiterlimit: 10
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/waves.33c4a178.svg";
export { ForwardRef as ReactComponent };